import axios from 'axios'
import _ from "lodash";

export default {
    data() {
        return {
            isCollective: false,
            selected: [],
            collectiveLoading: false,
            ppdetil: []
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    methods: {
        onCollective() {
            this.collectiveLoading = true;
            this.fetchList().then(res => {
                this.isCollective = true;
                this.EnCommission = true;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
                this.collectiveLoading = false
            })
        },
        handleCloseCollective() {
            Event.$emit("fetchDetilUm", true);
            this.isCollective = false;
            this.selected = [];
            this.formCollective.resetFields();
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].elm.innerText
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        async fetchList() {
            await axios({
                method: "get",
                params: {
                    id_um: this.collectData.informasi.id_um,
                },
                url: this.$serviceUrl + "lap_um_pp/um_detil",
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password
                },
                headers: {
                    "X-API-KEY": this.getAuth.apikey
                }
            }).then(response => {
                this.ppdetil = response.data.list_nama_item;
            }).catch(err => {
                this.displayMessageValue("basic-error", "UM Cannot Empty!")
            });
        },
        handleCheck(e) {
            const item = e.target.value;
            this.selected.filter(obj => obj.id == item.id).length == 0 ? this.selected.push(item) : this.selected.splice(this.selected.findIndex(obj => obj.id == item.id), 1)
        },
        handleSet(){
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.displayMessage("form-warning");
                    return;
                }
                let data = {}
                if (this.type == 'revised') {
                    data = {
                        "id_lk": this.mode == "Edit" ? this.id : this.id_lk,
                        "id_um_dtl": values.um_dtl,
                        "selected_item": this.selected,
                        "iscommision": values.iscommision,
                        "without_note": "1"
                    }
                } else {
                    data = {
                        "id_lk_draft": this.mode == "Edit" ? this.id : this.id_lk,
                        "id_um_dtl": values.um_dtl,
                        "iscommision": values.iscommision,
                        "without_note": "1",
                        "selected_item": this.selected
                    }
                }
                
                axios({
                    method: "put",
                    url: this.type == 'revised' ? this.$serviceUrl + "lap_um_pp/revisi_detil_pemakaian_kolektif" : this.$serviceUrl + "lap_um_pp/detil_pemakaian_kolektif",
                    processData: false,
                    data: data,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(res => {
                    this.handleChangeumDtl(null);
                    this.fetchList();
                    this.fetchPemakaian();
                    this.formCollective.resetFields();
                    this.selected = [];
                    this.checkAllCollective = false;
                    this.searchCollective = '';
                    this.displayMessage("success-save");
                }).catch(err => {
                    this.displayMessageValue("basic-error", err.response.data.message)
                })
            })
        },
        handleChangeumDtl(val){
            let selectedumDtl = _.filter(this.ppdetil, { id_um_dtl: val });
            if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
                this.EnCommission = true;
                this.Viwithout_note = false;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "1",
                    without_note: "0",
                });
                });
            }else{
                this.EnCommission = false;
                this.Viwithout_note = true;
                this.$nextTick(function () {
                this.formCollective.setFieldsValue({
                    iscommision: "0",
                    without_note: "0",
                });
                });
            }
        },
    }
}